import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";
import { Table, Tag } from 'antd';

import Chart from 'components/monitoring/Chart';

class Database extends React.Component {
	componentWillMount() {
	}

	render() {

		const chartData = {
			[this.props.dataApp.word]: [
				{
					id : this.props.dataKey.mongodb.name,
					data: this.props.getChartData(this.props.word, this.props.dataKey.mongodb.key)
				}
			],

			[this.props.dataApp.show]: [
				{
					id : this.props.dataKey.mongodb.name,
					data: this.props.getChartData(this.props.show, this.props.dataKey.mongodb.key)
				}
			],

			[this.props.dataApp.cell]: [
				{
					id : this.props.dataKey.mongodb.name,
					data: this.props.getChartData(this.props.cell, this.props.dataKey.mongodb.key)
				},
			],

			[this.props.dataApp.common]: [
				{
					id : this.props.dataKey.redis.name,
					data: this.props.getChartData(this.props.common, this.props.dataKey.redis.key)
				},
				{
					id : this.props.dataKey.mongodbGridFS.name,
					data: this.props.getChartData(this.props.common, this.props.dataKey.mongodbGridFS.key)
				},
			]
		}

		const tableData = [
			{
			  key: this.props.dataApp.word,
			  name: this.props.dataApp.word,
			  proccessInfo: [
					{
						name : this.props.dataKey.mongodb.name,
						state : this.props.lastData.word?.[this.props.dataKey.mongodb.key]
					}
			  ],
			},
			{
				key: this.props.dataApp.show,
				name: this.props.dataApp.show,
				proccessInfo: [
					{
						name : this.props.dataKey.mongodb.name,
						state : this.props.lastData.show?.[this.props.dataKey.mongodb.key]
					}
				],
			},
			{
				key: this.props.dataApp.cell,
				name: this.props.dataApp.cell,
				proccessInfo: [
					{
						name : this.props.dataKey.mongodb.name,
						state : this.props.lastData.cell?.[this.props.dataKey.mongodb.key]
					}
				],
			},
			{
				key: this.props.dataApp.common,
				name: this.props.dataApp.common,
				proccessInfo: [
					{
						name : this.props.dataKey.redis.name,
						state : this.props.lastData.common?.[this.props.dataKey.redis.key]
					},
					{
						name : this.props.dataKey.mongodbGridFS.name,
						state : this.props.lastData.common?.[this.props.dataKey.mongodbGridFS.key]
					}
				],
			},

		];
		
		const columns = [
			{
			  title: 'Service',
			  key: 'name',
			  dataIndex: 'name',
			  render: (text) => <a>{text}</a>,
			},
			{
				title: 'State',
				key: 'State',
				dataIndex: 'State',
				render: (_, { proccessInfo }) => (
				  <>
					{proccessInfo.map((data) => {
					  let color = (data.state) ? 'green' : 'volcano';			
					  return (
						<Tag style={{ marginBottom: '8px', display: 'block' }} color={color} key={data.name}> {data.name.toUpperCase()} </Tag>
					  );
					})}
				  </>
				),
			  },
			{
			  title: 'Monitoring',
			  key: 'chart',
			  render: (_, data) => {
				return (
						<Chart
							height='100'
							data={chartData[data.name]}
							max={'5'}
							min={'-5'}
						/>
				)
			  }
			},
		  ];

		return (
			<div>
				<Table 
					columns={columns} 
					dataSource={tableData} 
					pagination={false}
					size="middle"
				/>
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return{
		word: reducers.monitoring.word,
		show: reducers.monitoring.show,
		cell: reducers.monitoring.cell,
		common: reducers.monitoring.common,
		lastData: reducers.monitoring.lastData,
		dataApp: reducers.monitoring.dataApp,
		dataKey: reducers.monitoring.dataKey,
		apiCalling: reducers.apiCalling.apiCalling,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return{
		
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Database))